import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/posts/$id")({
  component: lazyRouteComponent(() => import("@/pages/admin/PostEditor")),
});
